import { styled, StyledImage } from '@raskrask-dk/rr-components'

export const DetailsHeader = styled('div', {
    display: 'flex',
    justifyContent: 'space-between',

    [`& ${StyledImage}`]: {
        justifySelf: 'flex-end',

        '@desktop': {
            maxW: 65,
        },

        '@mobile': {
            maxW: 50,
        },
    },
})

export const StyledBookingDetails = styled('div', {
    bgc: '$primary200',
    border: '1px solid $primary400',
    br: 4,
    p: 24,
})
